import { supabase } from '@/integrations/supabase/client';

/**
 * Test basic database connection by checking access to the profiles table.
 */
export const testBasicConnection = async () => {
  try {
    console.log('Health Check: Testing basic Supabase connection...');
    
    const { error, count } = await supabase
      .from('profiles')
      .select('id', { count: 'exact', head: true }); // Just get count for efficiency
    
    if (error) {
      console.error('Health Check Error: Basic connection test failed:', error);
      return { 
        success: false, 
        error: error.message,
        message: 'Failed to connect to Supabase profiles table'
      };
    }
    
    console.log('Health Check: Basic connection successful, profiles table accessible.');
    return { 
      success: true,
      message: 'Successfully connected to Supabase and accessed profiles table',
      profileCount: count // Optionally return the count
    };
  } catch (error) {
    console.error('Health Check Error: Unexpected error in basic connection test:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error',
      message: 'Failed to execute basic connection test'
    };
  }
}; 